import { render } from "./_admin-delete.vue?vue&type=template&id=597a6592&lang=pug"
import script from "./_admin-delete.vue?vue&type=script&lang=js"
export * from "./_admin-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__